import React from 'react';
import { TaskCard } from './TaskCard';
import { Task } from '../../types/task';
import { motion, AnimatePresence } from 'framer-motion';
import { useStore } from '../../store/useStore';

interface TaskListProps {
  tasks: Task[];
  showDepartment?: boolean;
}

export const TaskList: React.FC<TaskListProps> = ({ tasks, showDepartment = false }) => {
  const searchQuery = useStore(state => state.searchQuery);
  
  // Filter tasks based on search query
  const filteredTasks = React.useMemo(() => {
    if (!searchQuery) return tasks;
    
    const query = searchQuery.toLowerCase();
    return tasks.filter(task => 
      task.title.toLowerCase().includes(query) ||
      task.description.toLowerCase().includes(query) ||
      task.department.toLowerCase().includes(query) ||
      task.status.toLowerCase().includes(query)
    );
  }, [tasks, searchQuery]);

  if (filteredTasks.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        {searchQuery ? 'No tasks found matching your search.' : 'No tasks found.'}
      </div>
    );
  }

  return (
    <AnimatePresence>
      <div className="space-y-4">
        {filteredTasks.map((task) => (
          <motion.div
            key={task.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            <TaskCard
              task={task}
              showDepartment={showDepartment}
            />
          </motion.div>
        ))}
      </div>
    </AnimatePresence>
  );
};